export default class ConfigFromUrl {
  constructor($url, setting = {}) {
    Lc.f("ConfigFromUrl:constructor");
    this.url = $url;
    this._default = {};

    this.setting = _.extend(this._default, setting);
  }

  getDataFromTable($callback, opt = { id: "tbHelp" }) {
    Lc.f("ConfigFromUrl:getDataFromTable");
    Lc.log("opt", opt);
    Lc.log("this", this);

    $.get(this.url, function(data) {
      Lc.ajx("get");
      data = $(data).find("#" + opt.id);

      //---prochazeni tabulky

      var $i = 0;
      var $res = { help: {}, verze: false };
      data.find("tr").each(function() {
        if (!$i++) return;

        let $tr = $(this);
        if (
          $tr
            .find("td:first")
            .text()
            .trim() == ""
        )
          return;

        let $id = $tr
          .find("td:eq(0)")
          .text()
          .trim();
        let $val = $tr
          .find("td:eq(1)")
          .html()
          .trim();
        let $conf =
          $tr
            .find("td:eq(2)")
            .text()
            .trim() || false;

        if ($conf) {
          $res[$conf][$id] = $val;
        } else {
          $res[$id] = $val;
        }
      });

      $callback($res);
    });
  }
}
